import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { MarketingTopFoldBackground } from '@/components/marketing/hero-background'
import { MarketingFooter } from '@/components/marketing/marketing-footer'
import { MarketingHeader } from '@/components/marketing/marketing-header'
import { getRouteMeta, canonicalRouteUrl, type PrerenderPath } from '@/config/seo.config'

export function MarketingLayout() {
  const location = useLocation()

  // Per-route document title and production canonical URL.
  useEffect(() => {
    try {
      const path = location.pathname as PrerenderPath
      const meta = getRouteMeta(path)
      if (meta?.title) document.title = meta.title
      const canonical = document.querySelector('link[rel="canonical"]')
      if (canonical) canonical.setAttribute('href', canonicalRouteUrl(path))
    } catch {
      // Unknown path — keep the default document title and canonical.
    }
  }, [location.pathname])

  return (
    <div
      id="marketing-root"
      className="relative isolate flex min-h-screen flex-col overflow-x-clip"
    >
      {/* 2.4.1: skip link — first focusable element, visible on focus. */}
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <div
        aria-hidden
        className="marketing-page-gradient pointer-events-none absolute inset-0 -z-10"
      />
      <MarketingTopFoldBackground />
      <div className="relative z-10 flex flex-1 flex-col">
        <MarketingHeader />
        {/* Skip-link target. The single <main> landmark is provided by each
            routed page (this wrapper is a div to avoid nested <main>). */}
        <div id="main-content" tabIndex={-1} className="flex-1">
          <Outlet />
        </div>
        <MarketingFooter />
      </div>
    </div>
  )
}
